import React from 'react';
import { withRouter } from 'react-router-dom';
import { HiddenChat } from '../../Components/HiddenChat/HiddenChat.tsx';

export default withRouter((props) => (
  <HiddenChat userId={props.currentUser.id.toString()} />
));
